import React, { useMemo, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

const splitEmails = (value) => {
  if (!value) return [];
  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export default function ComposeEmailModal({ show, onClose, onSend }) {
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  const canSubmit = useMemo(() => splitEmails(to).length > 0 && subject.trim(), [to, subject]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSubmit || sending) return;

    const payload = {
      to: splitEmails(to),
      cc: splitEmails(cc),
      bcc: splitEmails(bcc),
      subject: subject.trim(),
      title: subject.trim(),
      body,
      content: body,
    };

    setSending(true);
    try {
      await onSend(payload);
      setTo("");
      setCc("");
      setBcc("");
      setSubject("");
      setBody("");
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>Compose Email</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label className="small text-muted">To</Form.Label>
            <Form.Control
              type="text"
              placeholder="recipient@example.com, another@example.com"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small text-muted">CC</Form.Label>
            <Form.Control
              type="text"
              placeholder="optional"
              value={cc}
              onChange={(e) => setCc(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small text-muted">BCC</Form.Label>
            <Form.Control
              type="text"
              placeholder="optional"
              value={bcc}
              onChange={(e) => setBcc(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small text-muted">Subject</Form.Label>
            <Form.Control
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small text-muted">Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              placeholder="Write your message..."
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={onClose} disabled={sending}>
            Close
          </Button>
          <Button variant="success" size="sm" type="submit" disabled={!canSubmit || sending}>
            {sending ? <Spinner animation="border" size="sm" /> : "Send"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
